module.exports = {"labels":{"fileNumber":"Sequencial","fileType":"Tipo de arquivo","submitButton":"Solicitar"},"fileTypes":[{"value":"TRT","label":"TRT"},{"value":"TRF","label":"TRF"},{"value":"TGT","label":"TGT"},{"value":"TAG","label":"TAG"},{"value":"NEL","label":"NEL"}],"simpleForm":{"title":"Solicitar lista","subtitle":"Solicite uma lista atualizada."}}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ec/RequestFile/data.json
// module id = 407
// module chunks = 0